import { IonCard, IonCardContent, IonIcon, IonModal } from "@ionic/react";
import { chevronForwardOutline } from "ionicons/icons";
import { FC, useMemo, useState } from "react";

import { IRateNegotiationBannerProps } from "./interfaces";
import { RateNegotiationsList } from "./negotiationsList";
import "./style.scss";

export const RateNegotiationBanner: FC<IRateNegotiationBannerProps> = ({
  activeNegotiationsCount,
  facilityProposalsCount,
  fetchShiftsAndNegotiations,
  deepLinkNegotiationId,
}) => {
  const [openNegotiationsList, setOpenNegotiationsList] = useState<boolean>(
    !!deepLinkNegotiationId
  );

  const hasActiveFacilityProposals = useMemo(() => {
    return facilityProposalsCount > 0;
  }, [facilityProposalsCount]);

  const facilityProposalsTitle = useMemo(() => {
    let title = "No new Workplace proposals";
    if (facilityProposalsCount > 0) {
      title = `${facilityProposalsCount} Workplace proposal`;
      if (facilityProposalsCount > 1) {
        title += "s";
      }
    }
    return title;
  }, [facilityProposalsCount]);

  const activeNegotiationsTitle = useMemo(() => {
    let title = "No active negotiations";
    if (activeNegotiationsCount > 0) {
      title = `Negotiating rates for ${activeNegotiationsCount} shift`;
      if (activeNegotiationsCount > 1) {
        title += "s";
      }
    }
    return title;
  }, [activeNegotiationsCount]);

  return (
    <>
      <IonCard
        className={`rate-negotiation-banner ${hasActiveFacilityProposals ? "active" : ""}`}
        data-testid="rate-negotiation-banner-card"
        onClick={() => {
          setOpenNegotiationsList(true);
        }}
      >
        <IonCardContent className="rate-negotiation-card-content">
          <div>
            <p className="rate-negotiation-banner-subtitle">{activeNegotiationsTitle}</p>
            <h2 className="rate-negotiation-banner-title">{facilityProposalsTitle}</h2>
          </div>
          <IonIcon
            data-testid="rate-negotiation-banner-chevron"
            className={`rate-negotiation-banner-chevron ${
              hasActiveFacilityProposals ? "active" : ""
            }`}
            icon={chevronForwardOutline}
          />
        </IonCardContent>
      </IonCard>
      {openNegotiationsList && (
        <IonModal
          isOpen={openNegotiationsList}
          onDidDismiss={() => {
            setOpenNegotiationsList(false);
            fetchShiftsAndNegotiations();
          }}
        >
          <RateNegotiationsList
            deepLinkNegotiationId={deepLinkNegotiationId}
            onClose={() => {
              setOpenNegotiationsList(false);
              fetchShiftsAndNegotiations();
            }}
          />
        </IonModal>
      )}
    </>
  );
};
